// export const getMonthStartAndEndDates = () => {
//     const now = new Date();
//     const startDate = new Date(now.getFullYear(), now.getMonth(), 1);
//     const endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0);
//     const formatDate = (date:any) => 
//       date.toLocaleDateString('en-CA'); 
//     return { startDate: formatDate(startDate), endDate: formatDate(endDate) };
//   };

export const getMonthStartAndEndDates = () => {
  const now = new Date();
  const startDate = new Date();
  startDate.setDate(now.getDate() - 30);

  const formatDate = (date: Date) =>
    date.toLocaleDateString('en-CA');

  return {
    startDate: formatDate(startDate),
    endDate: formatDate(now),
  };
};

  